/**
 * If you need more, please feel free to add them!
 * But keep in mind they should "globaly" make sense.
 * Don't add any custom formats. For custom formatting
 * we need to find a different solution.
 */
export var DateFormat;
(function (DateFormat) {
    DateFormat["MMHHDDMMYYY"] = "MMHHDDMMYYY";
    DateFormat["DDMMYYY"] = "DDMMYYY";
    DateFormat["MMHH"] = "MMHH";
})(DateFormat || (DateFormat = {}));
//# sourceMappingURL=DateFormat.js.map